import React from 'react';

import { Icon, Segment, Tooltip } from '@mairistem/composants';

interface ShowDiffContentProps {
  oldContent: string;
  newContent: string;
  'data-testid'?: string;
}

const ShowDiffContent = (props: ShowDiffContentProps) => {
  const { oldContent, newContent, 'data-testid': dataTestId } = props;
  const hasChanged = (oldContent || '').trim() !== (newContent || '').trim();

  if (
    newContent === 'Non renseigné' &&
    (oldContent === 'Non renseigné' || oldContent === '')
  ) {
    return <span data-testid={dataTestId}> : {newContent}</span>;
  }

  if (hasChanged) {
    return (
      <>
        <Tooltip
          mouseEnterDelay={100}
          trigger={
            <Icon
              name="history"
              data-testid={dataTestId && `${dataTestId}-historique`}
              style={{ marginLeft: '5px', marginRight: '0' }}
            />
          }
          content={
            <Segment>
              <span>
                <b>Ancienne valeur : </b>
              </span>
              <span>{oldContent}</span>
            </Segment>
          }
        />
        <span data-testid={dataTestId}> : {newContent}</span>
      </>
    );
  }
  return <span data-testid={dataTestId}> : {newContent}</span>;
};

export default ShowDiffContent;
